/* eslint-disable no-plusplus */
/* eslint-disable no-prototype-builtins */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

export const is_game_user = createAsyncThunk(
  '/live/game/is_game_user',
  async (arg, store: any) => {
    const resp = await http.post<
      HiyaRes<{
        is_white: boolean
      }>
    >(
      '/live/game/is_game_user',
      {},
      {
        store,
      }
    )
    // return {
    //   is_white: false,
    // }
    return resp.data.data
  }
)

const initialState: {
  is_white?: boolean
} = {}

export const UserVerificationSlice = createSlice({
  name: 'UserVerification',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(is_game_user.fulfilled, (state, action) => {
      Object.assign(state, {
        is_white: action.payload.is_white,
      })
    })
  },
})
export default UserVerificationSlice.reducer
export const UserVerificationActions = UserVerificationSlice.actions
